import { emptyString, requiredString } from './string';
import { url } from './url';

export const zTemplate = {
  url,
  requiredString,
  emptyString,
};
